export default "__VITE_PUBLIC_ASSET__6cb2508a__"